"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EmailType;
(function (EmailType) {
    EmailType["CHARGECARD"] = "charge-card";
    EmailType["ENRICHMENT"] = "enrichment";
    EmailType["ENRICHMENT_CONFIRMATION"] = "enrichment-confirmation";
    EmailType["ENRICHMENT_REMINDER"] = "enrichment-reminder";
    EmailType["QUOTATION"] = "quotation";
    EmailType["QUOTATION_APPROVED"] = "quotation-approved";
    EmailType["QUOTATION_EXPIRED"] = "quotation-expired";
    EmailType["QUOTATION_REMINDER"] = "quotation-reminder";
    EmailType["QUOTATION_SECOND_REMINDER"] = "quotation-reminder2";
    EmailType["QUOTATION_UPDATED"] = "quotation-updated";
    EmailType["INVOICE_NOTIFICATION"] = "invoice-notification";
    EmailType["NO_CONTACT"] = "no-contact";
    EmailType["LEAD_CONFIRMATION"] = "lead-confirmation";
    EmailType["REIMBURSEMENT_INITIAL"] = "reimbursement-initial";
    EmailType["REIMBURSEMENT_CONFIRMATION"] = "reimbursement-confirmation";
})(EmailType || (EmailType = {}));
exports.default = EmailType;
